<template>
  <span class="open-support-widget" :class="isFreshChatLoading?'disable-chat-btn':''"  onclick="contactSupport">contact support</span>
  <!-- <span class="open-support-widget" onclick="window.Freshbots.showWidget('open');">contact support</span> -->
</template>

<script>
import {loadFreshWorksWidgets} from '../../../util/freshchat'

export default {
  data(){
    return{
      isFreshChatLoading:false
    }
  },
  methods:{
    contactSupport(){
      this.isFreshChatLoading = true
      loadFreshWorksWidgets().then(()=>{
        // window.Freshbots.showWidget('open')
        this.isFreshChatLoading = false
      })
    },
  }
}
</script>

<style scoped>
.open-support-widget{
    cursor: pointer;
    color: #188bf6;
    font-weight: 600;
}
.disable-chat-btn{
  pointer-events: none;
}
</style>
